<template>
    <div id="lm-template-preview-modal">
      <LmComponentLoading v-if="isLoading" />
      <b-modal id="emailPreviewModal" title="Preview Email Template" size="lg" >
        <div id="email-preview" v-html="htmlEmailTemplateAsString"></div>
      </b-modal>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      htmlEmailTemplateAsString: '',
      isLoading: false
    }
  },
  methods: {
    async openEmailPreviewModal (value) {
      const isANumber = !isNaN(value)
      if (isANumber) {
        const idEmailTemplate = value
        try {
          this.isLoading = true
          const result = await axios.post(
            `${process.env.VUE_APP_API_URL}templates/email/preview/`,
            { id: idEmailTemplate }
          )
          this.htmlEmailTemplateAsString = JSON.parse(result.data.response)
          this.isLoading = false
        } catch (error) {
          console.log('error', error)
        } finally {
          this.isLoading = false
        }
      } else {
        const template = value
        this.htmlEmailTemplateAsString = template
      }
      this.$bvModal.show('emailPreviewModal')
    }
  }
}
</script>
